Pegasus.TextField = Ember.View.extend({
  templateName: 'controls/text_field',
  inputType: Ember.TextField,
  classNames: ['control-group'],
  classNameBindings: ['hasErrors:error'],
  hasErrors: Ember.computed.gt( 'errors.length', 0 ),

  inputElementId: function(){
    return Ember.generateGuid();
  }.property(),

  focusIn: function(){
    this.set('errors', []);
  },

  labelToTheSide: false,
  sideError: false,
  suppressErrors: false,
  showTopLabel: function() {
    return this.get('label') && !this.get('labelToTheSide');
  }.property('labelToTheSide'),
  showSideLabel: function() {
    return this.get('label') && this.get('labelToTheSide');
  }.property('labelToTheSide')
});
